import { router } from 'expo-router';
import React, { useEffect } from 'react';
import { View } from 'react-native';

export default function ProviderIndexScreen() {
  useEffect(() => {
    router.replace('/(tabs)/(provider)/home');
  }, []);

  return <View className="flex-1 bg-canvas" />;
}
